module.exports = __webpack_public_path__ + "static/media/barn.d83c5d21.png";